// extracted by mini-css-extract-plugin
export default {"disabled-panel":"MaNavBar_disabled-panel__YB6UM","button":"MaNavBar_button__ckHL+"};